import { LoginService } from './../services/auth/login.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Device } from '@capacitor/device';
import { LanguageService } from '../services/language/language.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ServiceInterceptor implements HttpInterceptor {

  constructor(private language: LanguageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (localStorage.getItem('token') != undefined) {
      let token = JSON.parse(localStorage.getItem('token') ?? '');
      let user = JSON.parse(localStorage.getItem('user') ?? '');

      token = String(token);
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          },
        });
      }
    }
    return next.handle(request);
  }
}
